// extracted by mini-css-extract-plugin
export default {"wrapper":"AdditionalNotes-wrapper-kWp"};